import { DsButtonBase } from "../DsButtonBase/DsButtonBase"
import { DsButtonsType } from "../DsButtonsTypes"

export type DsButtonPrimaryProps = DsButtonsType

export function DsButtonPrimary(props: DsButtonsType) {
  return <DsButtonBase {...props} variant="filled" />
}
